import { post,get, postpro, globalPut } from '../index';

export const createBrandSettings = data => {
    return post('/brand-settings', data, false);
  };

  export const updateBrandSettings = data => {
    return globalPut('/brand-settings', data, false);
  };

  export const getBrandSettings = (exportSettingsID) => {
    return get(`${'/brand-settings/brand'}/${exportSettingsID}`);
  };

  export const getRecentBrandSettings = (companyId) => {
    return get(`${'/brand-settings/company'}/${companyId}`);
  };

  export const updateBulkBrandSettings = data => {
    return globalPut('/brand-settings/bulk-update', data, false);
  };
